// extracted by mini-css-extract-plugin
export default {"group":"MenuGroup--group--246266","groupCheckbox":"MenuGroup--groupCheckbox--95e5eb"};